import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../store/hooks";
import { setHighlightedTasks } from "../../../store/search";

const VerticalBackgroundColumn = ({
  fill,
  xPosition,
  striped,
  width,
}: {
  fill?: string;
  xPosition: number;
  striped?: boolean;
  width?: number;
}) => {
  const dispatch = useDispatch();
  const { verticalColumnWidth } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const { pixelsPerHour, timelineRange } = useAppSelector(
    (state) => state.timelineSlice,
  );

  if (!verticalColumnWidth || !pixelsPerHour || !timelineRange) return null;

  const colWidth = width ?? verticalColumnWidth;
  const colHeight = timelineRange.fullDayHours * pixelsPerHour;

  return (
    <div
      style={{
        position: "absolute",
        left: xPosition,
        top: 0,
        width: colWidth,
        height: colHeight,
        backgroundColor: striped ? undefined : fill,
        background: striped
          ? `repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 1px,
              var(--col-border-primary) 2px,
              var(--col-border-primary) 4px
            )`
          : undefined,
      }}
      onClick={() => dispatch(setHighlightedTasks([]))}
    />
  );
};

export default VerticalBackgroundColumn;
